import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SidenavComponent } from '@components/sidenav/sidenav.component';

@NgModule({
    declarations: [SidenavComponent],
    exports: [SidenavComponent],
    imports: [MatIconModule],
})
export class SidenavModule { }